import React, { useState } from 'react';
import AuthField from './AuthField';
import Icon from '../../components/Icon';
import { Alert, Spinner } from '../../components/ui';
import { api } from '../../lib/api';

const MIN_PASSWORD = 6;
const BIO_MAX = 200;

export default function SignUpForm({ onDone }) {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [bio, setBio] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [sentTo, setSentTo] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim()) {
      setError('Pick a username so people know what to call you.');
      return;
    }
    if (password.length < MIN_PASSWORD) {
      setError(`Password must be at least ${MIN_PASSWORD} characters.`);
      return;
    }
    setError('');
    setBusy(true);
    try {
      await api.post('/api/auth/register', { username: username.trim(), email, password, bio: bio.trim() });
      setSentTo(email);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  if (sentTo) {
    return (
      <div className="auth-notice">
        <div className="auth-notice-icon">
          <Icon name="mail" size={26} />
        </div>
        <div className="auth-notice-title">Check your inbox</div>
        <p className="auth-notice-text">
          We sent a verification link to <strong style={{ color: 'var(--text)' }}>{sentTo}</strong>. Click it to
          activate your account, then sign in.
        </p>
        <button type="button" className="btn btn-gradient btn-lg btn-block" onClick={onDone}>
          Go to sign in
        </button>
      </div>
    );
  }

  return (
    <form className="auth-form" onSubmit={submit} noValidate>
      <AuthField
        label="Username"
        icon="user"
        value={username}
        onChange={setUsername}
        placeholder="How should we call you?"
        autoComplete="username"
        maxLength={30}
        required
      />
      <AuthField
        label="Email"
        icon="mail"
        type="email"
        value={email}
        onChange={setEmail}
        placeholder="you@example.com"
        autoComplete="email"
        required
      />
      <AuthField
        label="Password"
        icon="lock"
        type="password"
        value={password}
        onChange={setPassword}
        placeholder={`At least ${MIN_PASSWORD} characters`}
        autoComplete="new-password"
        required
      />
      <AuthField
        label="Short bio"
        icon="edit"
        value={bio}
        onChange={setBio}
        placeholder="One line about you"
        maxLength={BIO_MAX}
        hint={<><span>You can change this any time</span><span>{bio.length}/{BIO_MAX}</span></>}
      />
      {error && <Alert kind="error">{error}</Alert>}
      <button type="submit" className="btn btn-gradient btn-lg btn-block" disabled={busy}>
        {busy ? <Spinner label="Creating account" /> : 'Create account'}
      </button>
    </form>
  );
}
